// @flow
import { PRODUCT_CHILDCARES } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_CHILDCARE } from 'Utils/request/requestDictionary';
import { productChildcaresQuery } from 'Client/cms/toolkit/product-utils/productFeatures.queries';

export const productChildcaresResolver = {
  name: PRODUCT_CHILDCARES,
  resolve(
    appContext: AppContext,
    props: ProductChildcaresLineCMSProps,
    pageContext: PageContext,
    location: RouterLocation<ProductUrlParams>,
  ): Promise<ProductChildcaresLineProps> {
    const { urlParams } = location;
    const { resortId: productId } = props;
    const query = productChildcaresQuery(productId, { urlParams });
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_CHILDCARE,
      strictErrors: false,
    });
  },
};
